import React from 'react';

import { Channel } from '@make-transfer/types/common';

export interface MakeTransferContextProps {
  channels: Channel[],
  favoritesAvailable?: boolean,
  isReadOnlyImpersonatedSession?: boolean,
}

export const MakeTransferContext = React.createContext<MakeTransferContextProps>({
  channels: [],
  favoritesAvailable: false,
  isReadOnlyImpersonatedSession: false,
});
